import { useState, useEffect, useCallback, Fragment } from "react";
import useStyles from "./styles";
import PersonAddOutlinedIcon from "@material-ui/icons/PersonAddOutlined";
import Avatar from "@material-ui/core/Avatar";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import { useHistory, useParams, withRouter } from "react-router-dom";
import { useAuth } from "oidc-react";
import { ClientApp } from "../../interfaces/ClientApp";
import { Role } from "../../interfaces/Role";
import { App } from "../../interfaces/App";
import { MultiApp } from "../../interfaces/MultiApp";
import { UserMultiRole } from "../../interfaces/UserMultiRole";
import InputLabel from "@material-ui/core/InputLabel";
import FormControl from '@material-ui/core/FormControl';
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import ConfirmationDialog from "../ConfirmationDialog/ConfirmationDialog";
import { DialogOption } from "../ConfirmationDialog/DialogRawProps"

const AddRole = ({ ...props }: any) => {
    const MySwal = withReactContent(Swal);
    const { userId } = useParams<Record<string, string>>();

    const [clientApps, setClientApps] = useState<ClientApp[]>([]);
    const [uniqueClientApps, setUniqueClientApps] = useState<string[]>([]);
    const [clientAppSelected, setClientAppSelected] = useState("");

    const [apps, setApps] = useState<App[]>([]);
    const [appSelected, setAppSelected] = useState(0);

    const [options, setOptions] = useState<DialogOption[]>([]);

    const [optionsSelected, setOptionsSelected] = useState<MultiApp[]>([]);

    const handleChangeApp = (event: React.ChangeEvent<{value: unknown}>) => {
        setClientAppSelected(event.target.value as string);
        setApps([])
    };

    const handleOnClick = (appId: number) => {
        setAppSelected(appId);
      };

      const handleClose = (key?: number) => {

        const client = clientApps.find(client => client.aplicacionId === appSelected && client.nombre === clientAppSelected )

        const selections = optionsSelected.map((selection: any, index) => 
                index === appSelected 
                ? { aplicacionClienteId: client?.aplicacionClienteId, rolId: key} 
                : selection
            )

        setOptionsSelected(selections)  
    };

    const history = useHistory();
    var auth = useAuth();

    var classes = useStyles();

    useEffect(() => {
        memoClientApp();
        return () => {
            setClientApps([]);
          };
    }, []);

    useEffect(() => {
            memoApp();
            setOptionsSelected([])
            return () => {
                setApps([]);
              };
    }, [clientAppSelected]);

    useEffect(() => {
        if (appSelected !== 0) {
            memoRole();
            setOptionsSelected(optionsSelected.length === 0 ? 
                new Array(Math.max(...apps.map(app => app.aplicacionId)) + 1).fill({}) 
                : optionsSelected)
        }
        return () => {
            setOptions([]);
          };
    }, [appSelected]);

    var memoClientApp = useCallback(() => {
        clientAplicationsList();
    }, [clientApps]);

    var memoApp = useCallback(() => {
        var clients = clientApps.filter(
            (clientApp) => clientApp.nombre === clientAppSelected
        );
        var apps = [...new Set(clients.map((client) => client.aplicacion))];
        setApps(apps);
    }, [clientAppSelected]);

    var memoRole = useCallback(() => {
        setOptions([])
        rolesList();
    }, [appSelected]);

    const create = async (e: any) => {
        e.stopPropagation();
        e.preventDefault();

console.log(optionsSelected)

        const userRole: UserMultiRole = {
            usuarioId: +userId,
            multiApps: optionsSelected,
        };

        const response2 = await fetch(`/api/userrole`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                Authorization: "Bearer " + auth?.userData?.access_token,
            },
            body: JSON.stringify(userRole),
        });

        const result = await response2.json();

        if (response2.status === 200) {

            let trulyResponse = (result as number[]).includes(0)

            if (!trulyResponse && result.length > 0)
            {
                await MySwal.fire({
                title: <strong>Rol Asignado!</strong>,
                html: <i>Se ha asignado el rol de manera satisfactoria!</i>,
                icon: "success",
            });
            history.push(`/user/sendEmail/${userId}`);
            }

        }
    };

    const clientAplicationsList = async () => {
        const response = await fetch(
            `/api/clientapp?pageIndex=0&pageSize=100`,
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth?.userData?.access_token,
                },
                credentials: 'omit'
            }
        );
        if (response.status === 401) {
            history.push("/user");
            return;
        }

        const data = await response.json();

        setClientApps(data.items || []);

        var clientApps: ClientApp[] = data.items;

        const unique = [
            ...new Set(clientApps.map((clientApp) => clientApp.nombre)),
        ];

        setUniqueClientApps(unique);
    };

    const rolesList = async () => {
        const response = await fetch(
            `/api/role/${appSelected}`, 
            {
                method: "GET",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: "Bearer " + auth?.userData?.access_token,
                },
            }
        );

        if (response.status === 401) {
            history.push("/user");
            return;
        }
        const data = await response.json();

        let option: DialogOption[] = data.map( (role: Role) =>{ return {
            key: role.rolId.toString(),
            value: role.nombre,
            label: role.nombre,
        } as DialogOption})

        setOptions( option )
    };

    return (
        <Fragment>
            <Avatar className={classes.avatar}>
                <PersonAddOutlinedIcon />
            </Avatar>
            <Typography component="h1" variant="h5">
                Agregar Rol
            </Typography>
            <form className={classes.form}>
                {clientApps.length > 0 && (
                    <FormControl variant="outlined" fullWidth>
                        <InputLabel id="inputSelect">Clientes</InputLabel>
                        <Select
                            labelId="labelClientAppSelect"
                            id="clientAppSelect"
                            value={clientAppSelected}
                            label="Clientes"
                            onChange={handleChangeApp}
                            MenuProps={{
                                PaperProps: {
                                    onScroll: (event: any) => {
                                        if (
                                            event.target.scrollTop ===
                                            event.target.scrollHeight
                                        ) {
                                            //   setCategoryNamePagination(categoryNamePagination + 1);
                                        }
                                    },
                                },
                                style: { maxHeight: 300 },
                                id: "id-menu",
                                anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                },
                                getContentAnchorEl: null,
                            }}
                        >
                            <MenuItem value="">
                                <em></em>
                            </MenuItem>
                            {uniqueClientApps.map((clientApp) => (
                                <MenuItem key={clientApp} value={clientApp}>
                                    {clientApp}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                )}

                {apps?.length > 0 && (
                    <div className={classes.appsContainer}>
                        {apps.map(app => (
                            <div className={classes.apps} onClick={() => handleOnClick(app.aplicacionId)} key={app.aplicacionId}>
                            <ConfirmationDialog displayLabel={app.nombre} 
                            options = {options} onClose={handleClose}/>
                            </div>
                        ))}
                        
                    </div>
                )}

                <Button
                    type="button"
                    fullWidth
                    variant="contained"
                    color="primary"
                    className={classes.submit}
                    onClick={(e: any) => create(e)}
                >
                    Crear Rol
                </Button>
            </form>
        </Fragment>
    );
};

export default withRouter(AddRole);
